import { useEffect } from 'react';

let inertLockCount = 0;

const useInertAppRoot = (active: boolean): void => {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const root = document.getElementById('root');
    if (!root) {
      return undefined;
    }

    inertLockCount += 1;
    root.setAttribute('inert', '');

    return () => {
      inertLockCount = Math.max(0, inertLockCount - 1);
      if (inertLockCount === 0) {
        root.removeAttribute('inert');
      }
    };
  }, [active]);
};

export default useInertAppRoot;
